function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { useState, useEffect } from "react";
import { flagCache, observe } from "./cache";
import { upsert } from "./api";
import { enableDebug, getOverride, debugActive } from "./debug";
import { stringifyAndCompare } from "./utils";
/**
 * Stateful react hook returns the value of a launch darkly flag within a project by clientId
 * @param  {string} name: The name of the flag defined in Launch Darkly
 * @param  {*} defaultValue: The value which will be returned while awaiting remote flags
 * @param  {string} clientId: The Project+Env clientSideId as defined in Launch Darkly
 * @param  {*} log: logger for Sentry logging
 * @returns {*} Returns the value of a flag
 */ // eslint-disable-next-line sonarjs/cognitive-complexity
var useLaunchDarklyFlag = function(name, defaultValue, clientId, log) {
    if (defaultValue === void 0) defaultValue = false;
    // Backwards compatability layer - allows first param to be a object
    if (typeof name === "object" && name !== null) {
        var ref, ref1;
        // Destructure the object to get the parameters
        ref = name, name = ref.name, ref1 = ref.defaultValue, defaultValue = ref1 === void 0 ? false : ref1, clientId = ref.clientId, log = ref.log, ref;
    }
    // Sets initialState of the flag
    var _useState = _sliced_to_array(useState(function() {
        return computeValue(name, defaultValue, clientId, log);
    }), 2), flagValue = _useState[0], setFlagValue = _useState[1];
    useEffect(function() {
        if (typeof name !== "string" || typeof clientId !== "string") {
            return function() {};
        }
        // Returns the result of subscribe, which is the unsubscribe function
        return observe(clientId, function(updated) {
            return watchFlag({
                name: name,
                updated: updated,
                clientId: clientId,
                flagValue: flagValue,
                setFlagValue: setFlagValue,
                defaultValue: defaultValue
            });
        });
    }, [
        name,
        flagValue,
        clientId,
        defaultValue
    ]);
    useEffect(function() {
        // Hook value will correctly update if incoming props are dynamicly updated
        setFlagValue(computeValue(name, defaultValue, clientId, log));
    }, [
        name,
        clientId,
        defaultValue,
        computeValue,
        log
    ]);
    return flagValue;
};
// Abstracted computation allows hook to respond to updated name/clientId props
var computeValue = function(name, defaultValue, clientId, log) {
    var _flagCache_clientId_state_overrides, _flagCache_clientId_state, _flagCache_clientId, _flagCache, _flagCache_clientId_flags, _flagCache_clientId1, _flagCache1;
    // Force early return in SSR
    if (typeof window === "undefined") {
        return defaultValue;
    }
    // Insert into cache if missing, triggers fetches
    upsert({
        clientId: clientId,
        log: log
    });
    if (debugActive) {
        var override = getOverride({
            name: name,
            clientId: clientId
        });
        if (override !== undefined && override !== null) {
            if (!flagCache[clientId].state.overrides) {
                flagCache[clientId].state.overrides = {};
            }
            flagCache[clientId].state.overrides[name] = override;
        }
    }
    var _flagCache_clientId_state_overrides_name, _ref;
    return (_ref = (_flagCache_clientId_state_overrides_name = (_flagCache = flagCache) == null ? void 0 : (_flagCache_clientId = _flagCache[clientId]) == null ? void 0 : (_flagCache_clientId_state = _flagCache_clientId.state) == null ? void 0 : (_flagCache_clientId_state_overrides = _flagCache_clientId_state.overrides) == null ? void 0 : _flagCache_clientId_state_overrides[name]) != null ? _flagCache_clientId_state_overrides_name : (_flagCache1 = flagCache) == null ? void 0 : (_flagCache_clientId1 = _flagCache1[clientId]) == null ? void 0 : (_flagCache_clientId_flags = _flagCache_clientId1.flags) == null ? void 0 : _flagCache_clientId_flags[name]) != null ? _ref : defaultValue;
};
// This is the useLaunchDarklyFlag flagCache flag observer.
// It should watch for changes by comparing updated to current
// This step also applies the override feature immediatly before comparison
function watchFlag(param) {
    var name = param.name, updated = param.updated, clientId = param.clientId, flagValue = param.flagValue, setFlagValue = param.setFlagValue, defaultValue = param.defaultValue;
    var _flagCache_clientId, _updated_flags, _updated, _flagCache_clientId_state_overrides, _flagCache_clientId_state, _flagCache_clientId1, _flagCache;
    if (debugActive && ((_flagCache_clientId = flagCache[clientId]) == null ? void 0 : _flagCache_clientId.flags[name])) {
        var _flagCache_clientId_state1, _flagCache_clientId2;
        if (!((_flagCache_clientId2 = flagCache[clientId]) == null ? void 0 : (_flagCache_clientId_state1 = _flagCache_clientId2.state) == null ? void 0 : _flagCache_clientId_state1.overrides)) {
            flagCache[clientId].state.overrides = {};
        }
        var override = getOverride({
            name: name,
            clientId: clientId
        });
        if (override) {
            console.log({
                override: override,
                flagCache: flagCache
            });
            flagCache[clientId].state.overrides[name] = override;
        }
    }
    var updatedFlagValue = (_updated = updated) == null ? void 0 : (_updated_flags = _updated.flags) == null ? void 0 : _updated_flags[name];
    var _flagCache_clientId_state_overrides_name, _ref;
    var finalValue = (_ref = (_flagCache_clientId_state_overrides_name = (_flagCache = flagCache) == null ? void 0 : (_flagCache_clientId1 = _flagCache[clientId]) == null ? void 0 : (_flagCache_clientId_state = _flagCache_clientId1.state) == null ? void 0 : (_flagCache_clientId_state_overrides = _flagCache_clientId_state.overrides) == null ? void 0 : _flagCache_clientId_state_overrides[name]) != null ? _flagCache_clientId_state_overrides_name : updatedFlagValue) != null ? _ref : defaultValue;
    if (!stringifyAndCompare(finalValue, flagValue)) {
        // State update - will trigger 1 react re-render
        setFlagValue(finalValue);
    }
}
/**
 * A React hook that subscribes to and returns the cache status for a given client ID.
 * The hook initializes with a status from the flagCache or 'unknown' if no status is available.
 * It updates the status whenever changes are detected in the cache for the specified client.
 *
 * @param {string} clientId - The unique identifier for the client whose cache status is being monitored.
 * @returns {string} The current status of the cache for the given client ID.
 *
 * @example
 * // Example of using useCacheStatus within a React component
 * function DisplayCacheStatus({ clientId }) {
 *   const status = useCacheStatus(clientId);
 *
 *   return (
 *     <div>
 *       <p>Cache Status for {clientId}: {status}</p>
 *     </div>
 *   );
 * }
 */ var useCacheStatus = function(clientId) {
    var _flagCache_clientId_state_status;
    var _useState = _sliced_to_array(useState(function() {
        var _flagCache_clientId_state, _flagCache_clientId, _flagCache;
        return (_flagCache_clientId_state_status = (_flagCache = flagCache) == null ? void 0 : (_flagCache_clientId = _flagCache[clientId]) == null ? void 0 : (_flagCache_clientId_state = _flagCache_clientId.state) == null ? void 0 : _flagCache_clientId_state.status) != null ? _flagCache_clientId_state_status : "unknown";
    }), 2), cacheStatus = _useState[0], setCacheStatus = _useState[1];
    useEffect(function() {
        var _flagCache_clientId_state, _flagCache_clientId, _flagCache;
        if (!clientId) {
            return function() {};
        }
        var _flagCache_clientId_state_status;
        // When the component unmounts, unsubscribe from updates
        setCacheStatus((_flagCache_clientId_state_status = (_flagCache = flagCache) == null ? void 0 : (_flagCache_clientId = _flagCache[clientId]) == null ? void 0 : (_flagCache_clientId_state = _flagCache_clientId.state) == null ? void 0 : _flagCache_clientId_state.status) != null ? _flagCache_clientId_state_status : "unknown");
        return observe(clientId, function(updated) {
            var _updated_state, _updated;
            var _updated_state_status;
            setCacheStatus((_updated_state_status = (_updated = updated) == null ? void 0 : (_updated_state = _updated.state) == null ? void 0 : _updated_state.status) != null ? _updated_state_status : "unknown");
        });
    }, [
        clientId
    ]);
    return cacheStatus;
};
export { useLaunchDarklyFlag, useCacheStatus, enableDebug };
